/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCandidate = /* GraphQL */ `
  mutation CreateCandidate(
    $input: CreateCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    createCandidate(input: $input, condition: $condition) {
      id
      name
      email
      address
      zipCode
      city
      phoneNumber
      projectDescription
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCandidate = /* GraphQL */ `
  mutation UpdateCandidate(
    $input: UpdateCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    updateCandidate(input: $input, condition: $condition) {
      id
      name
      email
      address
      zipCode
      city
      phoneNumber
      projectDescription
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCandidate = /* GraphQL */ `
  mutation DeleteCandidate(
    $input: DeleteCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    deleteCandidate(input: $input, condition: $condition) {
      id
      name
      email
      address
      zipCode
      city
      phoneNumber
      projectDescription
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPortfolioImage = /* GraphQL */ `
  mutation CreatePortfolioImage(
    $input: CreatePortfolioImageInput!
    $condition: ModelPortfolioImageConditionInput
  ) {
    createPortfolioImage(input: $input, condition: $condition) {
      id
      category
      s3Key
      order
      alt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePortfolioImage = /* GraphQL */ `
  mutation UpdatePortfolioImage(
    $input: UpdatePortfolioImageInput!
    $condition: ModelPortfolioImageConditionInput
  ) {
    updatePortfolioImage(input: $input, condition: $condition) {
      id
      category
      s3Key
      order
      alt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePortfolioImage = /* GraphQL */ `
  mutation DeletePortfolioImage(
    $input: DeletePortfolioImageInput!
    $condition: ModelPortfolioImageConditionInput
  ) {
    deletePortfolioImage(input: $input, condition: $condition) {
      id
      category
      s3Key
      order
      alt
      createdAt
      updatedAt
      __typename
    }
  }
`;
